import { normalizeEntities } from 'helpers/utilHelpers';
import { fromJS } from 'immutable';
import {
  LOAD_REPORT_SUCCESS,
  LOAD_REPORT_PROJECTS_SUCCESS,
  CHANGE_REPORT_FILTER,
  UPDATE_TASK_IN_REPORT_SUCCESS,
  UPDATE_TIME_SUCCESS,
} from 'constants/ActionTypes';
import { DEFAULT_REPORT, DETAIL_REPORT, USER_REPORT } from 'constants/EntitiesConstants';

const initialState = fromJS({
  projects: {},
  tasks: {},
  detailMeta: {},
  filters: {
    type: DEFAULT_REPORT,
    projectId: 'all',
    userId: 'all',
    dateTo: null,
    dateFrom: null,
  },
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
  },
  dataset: [],
});

const getDataset = (items, type) => {
  switch (type) {
    case DETAIL_REPORT:
      return items.map((item) => parseInt(item.taskId));
    case USER_REPORT:
      return items.map((item) => parseInt(item.userId));
    default:
      return items.map((item) => parseInt(item.projectId));
  }
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_REPORT_SUCCESS: {
      const type = action.response?.type || state.getIn(['filters', 'type']);
      let tasks = { items: [] };
      let projects = { items: [] };
      let users = { items: [] };

      switch (type) {
        case DETAIL_REPORT:
          tasks = action.response;
          action.response.items.forEach((item) => {
            if (!projects.items.find((project) => project.projectId === item.projectId)) {
              projects.items.push({
                projectId: parseInt(item.projectId),
                isView: !!parseInt(item.isView),
                name: item.projectName,
              });
            }
          });
          break;
        case USER_REPORT:
          users = action.response;
          users.items = Object.values(users.items);
          break;
        default:
          action.response.items.forEach((item) => {
            item.tasks.forEach((task) => {
              tasks.items.push(task);
              if (!projects.items.find((project) => project.projectId === task.projectId)) {
                projects.items.push({
                  projectId: parseInt(task.projectId),
                  isView: !!parseInt(task.isView),
                  name: task.projectName,
                });
              }
            });
          });
          break;
      }

      tasks.items = tasks.items.map((task) => {
        return {
          ...task,
          userIds: task.userIds ? task.userIds.split(',') : [],
          userId: parseInt(task.userId),
          creatorId: parseInt(task.creatorId),
          coPerformerId: parseInt(task.coPerformerId),
          taskId: parseInt(task.taskId),
          projectId: parseInt(task.projectId),
        };
      });
      const newState = state.set(
        'projects',
        state.get('projects').merge(normalizeEntities(projects.items, 'projectId', state.get('projects'))),
      );

      let detailMeta = {},
        pagination = {
          totalCount: null,
          pageCount: null,
          currentPage: null,
          perPage: null,
        };
      detailMeta = action.response._meta.detailMeta;
      if (type !== DEFAULT_REPORT) {
        pagination = {
          totalCount: action.response._meta.totalCount,
          pageCount: action.response._meta.pageCount,
          currentPage: action.response._meta.currentPage,
          perPage: action.response._meta.perPage,
        };
      }

      return newState.merge(
        fromJS({
          tasks: normalizeEntities(tasks.items, 'taskId'),
          users: normalizeEntities(users.items, 'userId'),
          dataset: getDataset(action.response.items, action.response?.type || state.getIn(['filters', 'type'])),
          detailMeta,
          pagination,
        }),
      );
    }
    case UPDATE_TIME_SUCCESS: {
      let newState = state;
      let count = newState.getIn(['tasks', action.values.taskId, 'totalTime']);
      const rate = newState.getIn(['tasks', action.values.taskId, 'totalRate']);

      newState = count
        ? newState.setIn(['tasks', action.values.taskId, 'totalTime'], action.values.taskTotalTime)
        : newState;
      newState = rate
        ? newState.setIn(['tasks', action.values.taskId, 'totalRate'], action.values.taskTotalRate)
        : newState;

      return newState;
    }
    case LOAD_REPORT_PROJECTS_SUCCESS: {
      return state.set(
        'projects',
        state.get('projects').merge(normalizeEntities(action.response.items, 'projectId', state.get('projects'))),
      );
    }
    case UPDATE_TASK_IN_REPORT_SUCCESS: {
      return state.setIn(['tasks', action.value.taskId, 'endDate'], action.value.endDate);
    }
    case CHANGE_REPORT_FILTER:
      return state.setIn(['filters', action.filter], action.value);
    default:
      return state;
  }
};

export default reportReducer;
